module.exports = __webpack_public_path__ + "media/images/coupon/unfolding-d44a75e489d4b570499dd4ada6dc229b.svg";